import { MenuItem } from '@chakra-ui/react'
import { FC, useMemo, useState } from 'react'
import CsvDownloader from 'react-csv-downloader'
import { GrDocumentCsv } from 'react-icons/gr'

import useTools from '@hook/shared/use-tools'

import { parseReabMrpData } from '@helper/grid'

import { ILayoutToolsExportAction } from '@base/@types/components/Layout/Tools'

const ActionExcelReabMroExport: FC<ILayoutToolsExportAction> = ({
  headers,
  data,
  parser = parseReabMrpData
}) => {
  const { isDisabled } = useTools()
  const [isLoading, setLoading] = useState(false)

  const columns = useMemo(() => {
    const data: any[] = []

    for (const header of headers!) {
      if (!header.columns) continue

      for (const column of header.columns) {
        if (column.show) {
          data.push({
            id: column.id,
            displayName: `${header.group} - ${column.name}`
          })
        }
      }
    }

    return data
  }, [headers])

  const rows = useMemo(() => {
    const parsedData = parser(data)

    const body = []

    for (const row of parsedData) {
      const item: any = {}

      for (const column of columns) {
        item[column.id] = row[column.id]
      }

      body.push(item)
    }

    return body
  }, [columns, data, parser])

  return (
    <CsvDownloader
      filename={'MRP-Reab'}
      columns={columns}
      datas={rows}
      separator=";"
      wrapColumnChar='"'
      bom={true}
    >
      <MenuItem
        p="2px 12px"
        fontSize="sm"
        bgColor="white"
        _hover={{ bg: 'gray.400' }}
        isLoading={isLoading}
        loadingText="Fazendo Download"
        isDisabled={isDisabled}
        onClick={() => {
          setTimeout(() => {
            setLoading(false)
          }, 2000)
        }}
        icon={<GrDocumentCsv />}
      >
        Exportar para Tabela
      </MenuItem>
    </CsvDownloader>
  )
}

export default ActionExcelReabMroExport
